import { LinkProps } from "@generouted/react-router/client";
import { Navigate, useParams } from "react-router-dom";

import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useCanManageCareerPlanBool,
  useCanViewCareerPlanBool,
  useRequireCapability
} from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import type { Params } from "@/router";

import CareerPlanDocumentForm from "./_CareerPlanDocumentForm";

export default function CareerPlanDocumentPage({ mode }: { mode: "create" | "edit" }) {
  useRequireCapability({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewCareerPlan
  });
  const { pgaId, planId } = useParams();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded: capabilitiesLoaded } = useCapabilities();
  const canViewCareerPlan = useCanViewCareerPlanBool();
  const canManageCareerPlan = useCanManageCareerPlanBool();
  const careerTargetsEnabled = flags["pga-career-targets"] === true;
  const careerPlansEnabled = flags["pga-career-plan"] === true;

  if (!flagsLoaded || !capabilitiesLoaded) return null;
  if (!pgaId) return null;
  if (!careerTargetsEnabled || !careerPlansEnabled || !canViewCareerPlan) {
    return <Navigate to={`/people/${pgaId}/career/career-profile`} replace />;
  }
  if (mode === "create" && !canManageCareerPlan) {
    return <Navigate to={`/people/${pgaId}/career/career-profile`} replace />;
  }

  const backLink: LinkProps<"/people/:pgaId/career/career-profile", Params> = {
    to: "/people/:pgaId/career/career-profile",
    params: { pgaId },
    title: "Cancel"
  };

  if (mode === "edit") {
    if (!planId) return null;
    return <CareerPlanDocumentForm pgaId={pgaId} planId={planId} canManage={canManageCareerPlan} backLink={backLink} />;
  }

  return <CareerPlanDocumentForm pgaId={pgaId} canManage={canManageCareerPlan} backLink={backLink} />;
}
